module.exports = __webpack_public_path__ + "static/media/users-blue.c7c01058.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/pages/admin/users-blue.png
 ** module id = 562
 ** module chunks = 0
 **/